import { useLoginGuest } from '@carlito/hub-react';
import { BookingParticipant } from '@carlito/shared-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { eventParticipantDto } from '../shared/utils';

type LoginGuestProps = {
  birthDate?: string;
  hotelId: string;
  roomNumber?: string;
  bookingReference?: string;
};

export function useBookingGuestDetails() {
  const { t } = useTranslation();
  const guestLoginMutation = useLoginGuest();
  const [isLoadingGuest, setIsLoadingGuest] = useState<boolean>(false);

  const loginGuest = async ({
    hotelId,
    birthDate,
    bookingReference,
    roomNumber,
  }: LoginGuestProps) => {
    let isLoggedIn = false;
    let participants: BookingParticipant[] | undefined;

    try {
      setIsLoadingGuest(true);
      const loginResult = await guestLoginMutation.mutateAsync({
        hotelId,
        birthDate,
        bookingReference: bookingReference ? bookingReference : undefined,
        roomNumber: roomNumber ? roomNumber : undefined,
      });
      setIsLoadingGuest(false);
      if (
        loginResult &&
        loginResult?.currentReservation &&
        loginResult?.currentReservation.guests &&
        loginResult?.currentReservation?.guests?.length >= 1
      ) {
        isLoggedIn = true;
        participants = eventParticipantDto(loginResult.currentReservation, loginResult.guest?.id);
      }
      return { isLoggedIn, guest: loginResult?.guest, participants };
    } catch (e) {
      setIsLoadingGuest(false);
      return { isLoggedIn, error: t('booking-guest-not-found-error') };
    }
  };

  return {
    state: {
      isLoadingGuest,
    },
    actions: {
      loginGuest,
    },
  };
}
